import React,{useContext} from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import { useFormik } from 'formik';
import SearchService from './SearchService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { confirm } from "react-confirm-box";
import { Context } from '../../context/UserContext';

const initialValues = {
    serviceId: 0
}


const Index = () => {

    const context = useContext(Context);
    const [subServiceId,setSubServiceId] = useState(0);
    const { readData: changeSubServiceStockStatus } = useEntityCrud(`SubService/setsubServiceStockLock?Id=${subServiceId}`)
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const [businessList, setBusinessList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const { readDataByFilter: readDataSubService } = useEntityCrud('SubService/GetAllSubservices')
    const [data, setData] = useState([])
    const { statusData: changeStatus } = useEntityCrud("SubService/ChangeStatus")
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllServices')
    const [isLoading, setLoading] = useState(false);

    const [filterBTN, setFilterBTN] = useState(false);

    const navigate = useNavigate();
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: "",
        serviceId: ""
    })

    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')


    useEffect(() => {
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
    }, [])

    useEffect(() => {
        const postedData = {
            groupId: orgAddress?.groupId.value,
        };
        if (postedData.groupId) {
            readDataService(postedData).then(res => {
                if (res.data.result.length > 0) {
                    setServiceList(res.data.result)
                }
            });
        }

    }, [orgAddress?.groupId?.value])



    useEffect(() => {
        const postedData = {
            buisnessId: localStorage.getItem("buinessID"),
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
        });
    }, [localStorage.getItem("buinessID"), businessList])



    useEffect(() => {
        const postedData = {
            groupId: localStorage.getItem("groupID")
        };
        readDataService(postedData).then(res => {
            setServiceList(res.data.result)
        })
    }, [localStorage.getItem("groupID"), businessList])



    useEffect(() => {
        const postedData = {
            serviceId: localStorage.getItem("serviceID"),
        };
        readDataSubService(postedData).then(res => {
            setData(res.data.result)
        })
    }, [localStorage.getItem("serviceID"), businessList])



    const handleManagerID = (value) => {
    }



    const onSubmit = () => {

        setFilterBTN(true)

         
        const postedData = {
            serviceId: orgAddress.serviceId.value,
        };

        if (postedData.serviceId) {

            readDataSubService(postedData).then(res => {
                 
                if (res.status === 200) {
                    if (res.data.status === false) {
                        res.data.errors.map(error => toast.error(error.message));
                    }
                    else {
                        setData(res.data.result)
                        if (res.data.result.length === 0) {
                            toast.error('در این سرویس، محصول/خدمت موجود نمی باشد.');
                        }
                        navigate("/subService");

                        window.localStorage.setItem("buinessID", orgAddress.buisnessId.value);
                        window.localStorage.setItem("groupID", orgAddress.groupId.value);
                        window.localStorage.setItem("serviceID", orgAddress.serviceId.value);
                    }
                } else
                    res.data.errors.map(error => toast.error(error.message));
            }).catch(err => toast.error(err.message))

        }
    }

    const formik = useFormik({
        onSubmit,
        initialValues
    });


    const options = {
        render: (message, onConfirm, onCancel) => {
            return (
                <>
                    <h4 className="mb-3" style={{ fontSize: "20px" }}>{message} </h4>
                    <button className='btn btn-primary mx-1 px-4 py-2' onClick={onConfirm}> بله </button>
                    <button className='btn btn-secondary  px-4 mx-1  py-2' onClick={onCancel}> خیر </button>
                </>
            );
        }
    };


    const handleRemove = async (itemId, currentStatusId, serviceId) => {
         
        /*       const result = await confirm(
                  currentStatusId === 1 ? "  آیا از غیر فعال کردن زیر خدمت مورد نظر اطمینان دارید؟ " : "  آیا از  فعال کردن زیر خدمت مورد نظر اطمینان دارید؟ ", options);
       */
        /*     if (result) { */
        const body = {
            id: itemId,
            status: currentStatusId === 1 ? false : true
        }

        changeStatus(body).then(res => {
             
            const newData = data.map(item => {
                if (item.id === itemId)
                    return { ...item, isActive: currentStatusId === 1 ? 0 : 1 }
                else
                    return item
            })
            toast.success('وضعیت محصول/خدمت مورد نظر با موفقیت به روزرسانی شد');

            setData(newData);

        }).catch(err => {
            toast.error(<p className='rtl-input'>'متاسفانه محصول/خدمت حذف نشد'</p>)
        })
        /*       } */
    }

    const handleNotInStock = itemId => {
        setSubServiceId(itemId)
    }

    useEffect(() => {
        if(subServiceId){
            changeSubServiceStockStatus().then(({data}) => {
                if(data.status)
                    toast.success('ثبت اتمام موجودی با موفقیت انجام شد');
                else
                    toast.error('عملیات ثبت اتمام موجودی ناموفق بود');
            })
        }
    },[subServiceId])

    return (
        <>
            {/*       <div className="page-header my-0">
                <h1 class="page-title"> زیر خدمت ها</h1>
            </div> */}

            <div className="card">
                <div className="card">
                    <div className="card-header p-2 py-4">
                        <h3 className="card-title">
                            {/*                             <i className='fa fa-list px-1'></i>
 */}                            محصول/خدمت </h3>
                    </div>
                    <div className="card-body">
                        {context.checkHasPermission('create') ? <Link className="btn btn-primary mb-2" to="create">ایجاد محصول/خدمت</Link> : ''}

                        <div class="alert alert-info" role="alert">
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                            <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                            جهت نمایش لیست محصول/خدمت ها لطفا یک  خدمت را انتخاب کنید.
                        </div>
                        {isLoading ?
                            <div class="lds-facebook" >
                                <div></div>
                                <div></div>
                                <div></div>
                            </div >
                            :
                            <>
                                <SearchService formik={formik}
                                    serviceList={serviceList} setServiceList={setServiceList}
                                    groupList={groupList} setGroupList={setGroupList}
                                    businessList={businessList} setBusinessList={setBusinessList}
                                    orgAddress={orgAddress} setOrgAddress={setOrgAddress}
                                    filterBTN={filterBTN} setFilterBTN={setFilterBTN} />

                                {data?.length > 0 ? (localStorage.getItem('rl') != 3 ? <div className="table-responsive">
                                    <table className="table table-hover border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th width="1%" className='text-center' >ردیف</th>
                                                <th>  سرویس</th>
                                                <th>    عنوان محصول/خدمت </th>
                                                <th>قیمت (ریال)  </th>
                                                <th>  وضعیت</th>
                                                <th>عملیات</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item, index) =>
                                                <tr>
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td> {serviceList.find(element => element.id === (item.serviceId || parseInt(localStorage.getItem("serviceID"))))?.title} </td>

                                                    <td>  {item.title}</td>

                                                    <td>{new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(item.price)}</td>


                                                    <td>  {item.isActive === 1 ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>} </td>
                                                    <td>
                                                        {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                            <i className="fe fe-edit-2"></i>
                                                        </Link> : ''}


                                                        {/*         <button
                                                            className="btn btn-danger d-inline m-1 btn-icon d-inline"
                                                            type="button"
                                                            variant="danger"
                                                            onClick={() => handleRemove(item.id, item.isActive, item.serviceId)}
                                                        >
                                                            {item.isActive === 1 ?
                                                                <i className="fe fe-x text-white"></i>
                                                                :
                                                                <i className="fe fe-check text-white"></i>
                                                            }
                                                        </button> */}
                                                        {context.checkHasPermission('delete') ? (item.isActive === 1 ?
                                                            <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                                className="btn btn-icon mb-0 btn-danger">
                                                                <i className="fe fe-x"></i>
                                                            </button>
                                                            : <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                                className="btn btn-icon mb-0 btn-success">
                                                                <i className="fe fe-check"></i>
                                                            </button>) : ''}




                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div> : 
                                <div className="row">
                                    {data.map((item, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="card custom-border-1">
                                                <div className="row">
                                                    <div className="col-md-3"><p>سرویس: {serviceList.find(element => element.id === (item.serviceId || parseInt(localStorage.getItem("serviceID"))))?.title}</p></div>
                                                    <div className="col-md-3"><p>عنوان: {item.title}</p></div>
                                                    <div className="col-md-3"><p>قیمت (ریال): {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(item.price)}</p></div>
                                                    <div className="col-md-3"><p>وضعیت: {item.isActive === 1 ? <span className="text-success">فعال</span> : <span className="text-danger">غیرفعال</span>}</p></div>
                                                </div>
                                                <div className="operation-btn-group">
                                                <button onClick={() => handleNotInStock(item.id)}
                                                                className="btn btn-icon mb-0 btn-dark">
                                                                ثبت اتمام موجودی
                                                            </button>
                                                {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                            <i className="fe fe-edit-2"></i>
                                                        </Link> : ''}


                                                        {/*         <button
                                                            className="btn btn-danger d-inline m-1 btn-icon d-inline"
                                                            type="button"
                                                            variant="danger"
                                                            onClick={() => handleRemove(item.id, item.isActive, item.serviceId)}
                                                        >
                                                            {item.isActive === 1 ?
                                                                <i className="fe fe-x text-white"></i>
                                                                :
                                                                <i className="fe fe-check text-white"></i>
                                                            }
                                                        </button> */}
                                                        {context.checkHasPermission('delete') ? (item.isActive === 1 ?
                                                            <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                                className="btn btn-icon mb-0 btn-danger">
                                                                <i className="fe fe-x"></i>
                                                            </button>
                                                            : <button onClick={() => handleRemove(item.id, item.isActive, item.groupId)}
                                                                className="btn btn-icon mb-0 btn-success">
                                                                <i className="fe fe-check"></i>
                                                            </button>) : ''}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                ) : ""
                                }
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default Index;